The URL of the video to display.

Scheme requirements:

- The `seekAnz` scheme requires a YouTube link in one of the following formats:

  - `https://www.youtube.com/embed/aAgePQvHBQM`
  - `https://www.youtube.com/watch?v=aAgePQvHBQM`
  - `https://youtube.com/embed/aAgePQvHBQM`
  - `https://youtube.com/watch?v=aAgePQvHBQM`
  - `https://youtu.be/aAgePQvHBQM`

  If the URL provided does not match the above criteria it will be ignored.
  Examples of unsupported formats include:

  - Links with additional query parameters: `https://www.youtube.com/watch?ab_channel=SEEKJobs&v=aAgePQvHBQM`
  - Mobile links: `https://m.youtube.com/watch?v=aAgePQvHBQM`
